import type React from 'react';
import { useEffect } from 'react';
import { useApp } from '@/forApp/states/appState/appState';
import InputRange from '@/shared/Inputs/InputRage/InputRange';
import SimpleSelect, { type ItemSelectT } from '@/shared/Selects/Select';
import SelectAddressAutocomplite, {
  type AddressOption,
} from '@/shared/Selects/selects-autocomplite/selects-autocomplite-address/selectAutocompliteAddress';
import type { DefaultFilterT } from '@/widgets/MainBlock/MainSearch/types';
import RoomSelection from './RoomSelection/RoomSelection';
import styles from './styles.module.css';

type DinamycSearchTProps = {
  onChange?: (value: string) => void;
  dataForFilters: DefaultFilterT;
  isMobile?: boolean;
};

const DinamycSearch: React.FC<DinamycSearchTProps> = ({
  dataForFilters,
  isMobile,
}) => {
  const { allowFilters, typeEntity } = dataForFilters;
  const { filters, setFilters } = useApp();
  const type = filters.type as string;

  useEffect(() => {
    setFilters('extraType', typeEntity[type][0].value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type]);

  const onChangeExtraType = (value: ItemSelectT | null) => {
    if (!value) return;
    setFilters('extraType', value.value);
  };

  const onChangeCity = (value: ItemSelectT | null) => {
    if (!value) return;
    if (value.title === 'Все города') {
      setFilters('filters[city]', '');
      return;
    }
    setFilters('filters[city]', value.title);
  };

  // const onChangeOnRange = (key: string, value: string) => {
  // 	setFilters(key, value);
  // };
  const onChangeAddress = (value: AddressOption) => {
    if (!value) return;
    setFilters('address', value.value);
  };

  // const onOpenModal = () => {
  // 	addModal({
  // 		name: "OtherFiltersModal",
  // 		moreFilter,
  // 		allowFilters,
  // 	});
  // };

  return (
    <>
      <div className={styles.dinamycSearch}>
        {typeEntity[type]?.length && allowFilters.cities.length ? (
          <div className={styles.selectBlock}>
            {typeEntity[type]?.length ? (
              <SimpleSelect
                options={typeEntity[type]}
                selected={typeEntity[type].find(
                  (item) => item.value === filters.extraType,
                )}
                onChange={onChangeExtraType}
                placeholder={'Тип объекта'}
                instanceId="react-select-3"
              />
            ) : null}
            {allowFilters.cities.length ? (
              <SimpleSelect
                options={allowFilters.cities}
                defaultValue={
                  allowFilters.cities.find((item) => {
                    return item.value === filters['filters[city]'];
                  }) || { value: '', title: 'Все города' }
                }
                onChange={onChangeCity}
                placeholder={'Город'}
                instanceId="react-select-5"
              />
            ) : (
              ''
            )}
          </div>
        ) : null}
        <div className={styles.inputRangeBlock}>
          {allowFilters.filters.map((item, index) => {
            if (item.type === 'InputRange') {
              return (
                <div key={item.title + index}>
                  <InputRange
                    size={
                      isMobile && window
                        ? window.innerWidth / 2 - 12
                        : undefined
                    }
                    filterName={item.type}
                    onChangeFrom={setFilters}
                    onChangeTo={setFilters}
                    fromPlaceholder={item.filters[0].name}
                    toPlaceholder={item.filters[1].name}
                    fromKey={'filters' + item.filters[0].filter}
                    toKey={'filters' + item.filters[1].filter}
                  />
                </div>
              );
            } else {
              return null;
            }
          })}
        </div>
      </div>
      <div className={styles.filterBlock}>
        {allowFilters.filters.map((item, index) => {
          if (item.title === 'Комнатность') {
            return (
              <RoomSelection
                key={item.title + index}
                roomsData={item}
                isMobile={isMobile}
              />
            );
          } else {
            return null;
          }
        })}
      </div>
      <div className={styles.lastBlock}>
        <SelectAddressAutocomplite
          onChange={onChangeAddress}
          placeholder={'Поиск по адресу'}
        />
        {/*    <Button icon={<Icons.Filter/>} text={'Все фильтры'} className={styles.buttonOtherFilter} onClick={onOpenModal} color={'white'} iconPosition={'right'}  />
         */}
      </div>
    </>
  );
};

export default DinamycSearch;
